const createReducer =
  (initialState, reducerMap) =>
  (state = initialState, action) =>
    (reducerMap[action.type] && reducerMap[action.type](state, action)) || state;

export default createReducer;
